import { useMemo, useState } from "react";

import date from "date-and-time";

import { createColumnHelper } from "@tanstack/react-table";

import PagedTable from "../shared/Tables/PagedTable";
import TableCheckboxCol from "../shared/Tables/IndeterminateCheckbox";
import { IEbayReturn } from "../../models/EbayReturns";
import EbayReturnsModal from "./EbayReturnsModal";

const colHelper = createColumnHelper<IEbayReturn>();

export default function EbayReturnsTable() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedReturn, setSelectedReturn] = useState<IEbayReturn | undefined>();

  const cols = useMemo(
    () => [
  TableCheckboxCol(true, false),
  colHelper.accessor("sellerResponseDue", {
    header: "Respond On or By",
    sortingFn: "auto",
    cell: (info) => <span>{info.getValue() !== null ? date.format(new Date(info.getValue()!.respondByDate.value), "DD/MM/YYYY") : "Unknown"}</span>,
  }),
  colHelper.accessor("buyerLoginName", {
    header: "Buyer",
    sortingFn: "auto",
  }),
  // colHelper.accessor("creationInfo", {
  //   header: "Creation Date",
  //   sortingFn: "auto",
  //   cell: (info) => <span>{info.getValue() !== null ? date.format(new Date(info.getValue()!.creationDate.value), "DD/MM/YYYY hh:mm") : "Not Set"}</span>,
  // }),
  colHelper.accessor("state", {
    header: "State",
    sortingFn: "auto",
  }),
  colHelper.accessor("creationInfo", {
    header: "Reason",
    sortingFn: "auto",
    cell: (info) => <span>{info.getValue().reasonType} - {info.getValue().reason}</span>,
  }),
  ],
    []
  );

  const rowSelected = (row: IEbayReturn) => {
    setSelectedReturn(row);
    setModalOpen(true);
  }

  return (<>
    <EbayReturnsModal open={modalOpen} setOpen={setModalOpen} ebayReturn={selectedReturn} />
    <PagedTable
      url="/ebaysafe/returns/search"
      customUrlQuery=""
      columns={cols}
      queryLabel="Search order details"
      onRowClick={(x: IEbayReturn) => rowSelected(x)}
    />
  </>
  );
}
